import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "../assets/css/form.css";
import "../assets/css/login.css";
import "../assets/css/button.css";
import "../assets/css/otp-box.css";
import BackArrowIcon from "../assets/img/back-arrow-icon.svg";
import Logo from "../assets/img/ibridge-logo.svg";
import LogoBlue from "../assets/img/ibridge-logo-blue.svg";
import LoginImage from "../assets/img/login-image.png";
import { validateEmail, formatOtpMobileNumber } from "../Helper/common";
import Footer from '../components/Footer.js';

import { useDispatch, useSelector } from "react-redux";

import { loginUser, validateOtp } from "../Actions/userActions";
import { useParams, useNavigate } from "react-router-dom";
import { FOLDERPATH } from "../Constants/config";

import { toast } from "react-toastify";


const ForgotPassword = () => {
 
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const email = useRef();


  const [isSubmit, setIsSubmit] = useState(false);
  const [verifyClick,setVerifyClick]=useState(false);
  const [formError, setFormError] = useState({});
  const [emailAddress, setEmailAddress] = useState('');
  // const [loginValidated, setLoginValidated] = useState(0);

  const formValidation = (formValues) => {
    const errors = {};

    if (formValues.email === "") {
      errors.email = "This field is required.";
      email.current.style.border = "1px solid red";
    } else {
      email.current.style.border = "1px solid #E1E4EB";
      if (!validateEmail(formValues.email)) {
        errors.email = "Not a valid email addess";
        email.current.style.border = "1px solid red";
      } else {
        email.current.style.border = "1px solid #E1E4EB";
      }
    }

    return errors;
  };

  const formData = {};

  const signinHandler = (event) => {
    event.preventDefault();
   
    
    formData.email = email.current.value;
   
    const err = formValidation(formData);
    // setIsSubmit(true);
    const isValidationPassed = Object.keys(err).length === 0;

    if (!isValidationPassed) {
      setFormError(err);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    } else {

      console.log(formData);

      setVerifyClick(true);

      sendForgotPassword(formData.email)

     // resetOtpHandler();
     // dispatch(loginUser(formData));
    
    }
  };


  //////////////////////////////////////
  // const storeData = useSelector((state) => state.user);
  // const { userData, loading, error } = storeData;

  ////////////////////////////////////////////////////////////////////////////



  //////////////////////////////////////
  // const storeOtpData = useSelector((state) => state.verifyOtp);
  // const { otpData, loading: otpLoading, error: otpError } = storeOtpData;

  ////////////////////////////////////////////////////////////////////////////


  // const backHandler = (event) => {
  //   formData.email="";
  //   formData.password="";
  //   setLoginValidated(0);
  // };


  

  const sendForgotPassword = (email) => {
    let apiCompanyData;

    const runAPi = async () => {
      const requestData = {
        email_address: email,
      };
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
      apiCompanyData = await axios.post( FOLDERPATH + 
        "/GenericApi/forgotPasswordCandidate",
        requestData,
        {
          headers,
        }
      );

      console.log(apiCompanyData);

    //    useEffect(()=>{
    //     if(apiCompanyData.data.status=='error'){
    //  setVerifyClick(false);
    //     }
      

    //    },[apiCompanyData.data.status]);

      if(apiCompanyData.data.status === 'error'){

        setVerifyClick(false);

        const msg = apiCompanyData.data.message;

        toast.error(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId: 'forget-password-error',
        });
        setEmailAddress('');
        setIsSubmit(false);
      }else{

        setVerifyClick(false);

        const msg = "Email sent successfully";

        toast.success(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId: 'forget-password-success',
        });
        setEmailAddress(email);
        setIsSubmit(true);
      }
    
      
      // navigate('/login');


    };

    runAPi();
  };




  return (
    <section className="login-page h-100">
      <div className="container-fluid main-container">
        <div className="row main-row">
          <div className="col-sm-6 col-md-12 col-xl-6 left-sec h-100">
            <div className="p-4 h-100">
              <img src={Logo} alt="" className="desktop-logo" />

              <div className="d-flex align-items-center justify-content-center flex-column h-100">
                <img
                  src={LoginImage}
                  alt=""
                  className="mt-3 mb-3 img-fluid login-image"
                />
                <div>
                  <h3 className="text-white fnt-smi-bld mb-4">AuthBridge</h3>
                  <p style={{ color: "#D0D5DD" }}>
                    With global capabilities, flagship identity management and
                    verification products, we have 1500+ happy customers across
                    25+ industries. We are driven by intelligent innovation and
                    a passion to build a secure world using technology.
                  </p>
                  <p style={{ color: "#D0D5DD" }}>
                    We are a trusted partner for all the stakeholders of the new
                    economy, we are market leaders and have helped shaped the
                    RegTech infrastructure in India.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`col-sm-6 col-md-12 col-xl-6 right-sec align-items-center justify-content-center flex-column d-flex`}
          >

           <div className="back-btn d-flex align-items-center">
              <img src={BackArrowIcon} alt="" className="mr-2" />
              <Link to="/login" className="text-primary fnt-sml-md fnt-sml">
              <span className="text-primary">
                Back to log in
              </span>
              </Link>
            </div>

            
            <img src={LogoBlue} alt="" className="mobile-logo mb-4" />
            <form className="d-flex" onSubmit={signinHandler}>
              {
                !isSubmit ?
                <>
                  <div className="m-4 form">
                    <h4 className="fnt-bld text-center">Resend Password</h4>
                    <p
                      className="fnt-sml-md text-center"
                      style={{ color: "#667085" }}
                    >
                      Welcome back! Please enter your email.
                    </p>



                    <div className="">
                      <div className="form-group">
                        <label htmlFor="" className="fnt-smi-bld">
                          Email
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter your email"
                          ref={email}
                        />
                        <p className="text-danger">{formError.email}</p>
                      </div>

                      {/* <div className="text-right">
                  <Link to="/forgot-password" className="text-primary fnt-sml-md fnt-sml">Forgot Password</Link>
                </div> */}

                      {/* <div className="re-captcha-box text-center d-flex justify-content-center mt-3">
                  <ReCAPTCHA
                    ref={captcha}
                    sitekey="6LffKE4UAAAAAD_CbxeHNWBGA45iUT_4ZUy0uIGs"
                      // onChange={() => {
                      //   captcha.current.reset(); // here
                      // }}
                  />
                </div> */}

                      <button
                        className="btn btn-primary btn-block mt-3 btn-login"
                        // onClick={signinHandler}
                        type="submit"
                        disabled={verifyClick}
                      // onClick={(e)=>{setVerifyClick(true); console.log(e)}}
                      //{verifyClick==true ? disabled:""}
                      >
                        Submit {verifyClick === true && <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                      </button>
                    </div>


                    <div className="text-center fnt-sml mt-3">
                      <span className="text-muted">Unable to sign in? </span>
                      <a href="https://authbridge.com/contact-us" target="_blank" className="text-primary">
                        Contact Support
                      </a>
                    </div>

                  </div>
                </> : <>
                <div className="m-4 form" id="email-submit-message">
                    <h4 className="fnt-bld" style={{fontSize : 30}}>Check your email</h4>
                    <p
                      className="fnt-sml-md"
                      style={{ color: "#667085" }}
                    >
                      {`We’ve sent an email to ${emailAddress}. If you don't see the email, check other places it might be, 
                      like mail junk, spam, updates etc.`}
                    </p>
                    <button
                        className="btn btn-primary btn-block mt-3 btn-login"
                        id="btn-back-login"
                        onClick={(e)=>{navigate('/login');}}
                      >
                        Back to login 
                    </button>

                    </div>
                </>
              }
            </form>
              <div className="copyright-login">
                <Footer/>
              </div>
          </div>

        </div>
      </div>
    </section>
  );
};
export default ForgotPassword;
